export const UPLOAD_SLOT_TYPES = {
  rentalLedger: 'rental-ledger',
  identityFront: 'identity-front',
  identityBack: 'identity-back',
  incomeDoc1: 'income-doc-1',
  incomeDoc2: 'income-doc-2',
  incomeDoc3: 'income-doc-3',
  visaGrant: 'visa-grant-notice',
  internationalCoe: 'international-coe',
  enrollmentLetter: 'enrollment-letter',
  letterOfAuthority: 'letter-of-authority',
  incomeStatement: 'income-statement',
  bankStatement: 'bank-statement',
  savingsStatement: 'savings-statement',
} as const

export type UploadSlotType = (typeof UPLOAD_SLOT_TYPES)[keyof typeof UPLOAD_SLOT_TYPES]

export type UploadSlotDefinition = {
  type: UploadSlotType
  label: string
  name?: string
  helperText?: string
  required?: boolean
  showRequired?: boolean
  optional?: boolean
  allowPreview?: boolean
  isSavedForLater?: boolean
  stronglyRecommended?: boolean
  showMyGovLink?: boolean
  myGovLinkUrl?: string
}

export const identityUploadSlots: UploadSlotDefinition[] = [
  {
    type: UPLOAD_SLOT_TYPES.identityFront,
    label: 'Front of ID',
    name: '',
    required: true,
    showRequired: true,
    allowPreview: false,
  },
  {
    type: UPLOAD_SLOT_TYPES.identityBack,
    label: 'Back of ID',
    name: '',
    required: true,
    showRequired: true,
    allowPreview: false,
  },
]

export const incomeUploadSlots: UploadSlotDefinition[] = [
  {
    type: UPLOAD_SLOT_TYPES.incomeDoc1,
    label: 'First document',
    name: '',
    required: true,
    allowPreview: false,
  },
  {
    type: UPLOAD_SLOT_TYPES.incomeDoc2,
    label: 'Second document',
    name: '',
    required: true,
    allowPreview: false,
  },
  {
    type: UPLOAD_SLOT_TYPES.incomeDoc3,
    label: 'Third document',
    name: '',
    optional: true,
    allowPreview: false,
  },
]

export const benefitUploadSlots: UploadSlotDefinition[] = [
  {
    type: UPLOAD_SLOT_TYPES.incomeStatement,
    label: 'Income Statement',
    name: '',
    helperText:
      'Centrelink Income Statement dated within the last 2 weeks, covering all your payments.',
    required: true,
    showRequired: false,
    allowPreview: false,
    showMyGovLink: true,
  },
  {
    type: UPLOAD_SLOT_TYPES.bankStatement,
    label: 'Bank Statement (last 3 months, showing benefit deposits)',
    name: '',
    helperText: 'Helps confirm regular benefit deposits.',
    required: false,
    optional: true,
    allowPreview: false,
    stronglyRecommended: true,
  },
  {
    type: UPLOAD_SLOT_TYPES.savingsStatement,
    label: 'Savings statement (last 3 months, showing you can cover tight months)',
    name: '',
    helperText: 'Helps show a buffer for slower weeks.',
    optional: true,
    allowPreview: false,
    stronglyRecommended: true,
  },
]

export const visaUploadSlots: UploadSlotDefinition[] = [
  {
    type: UPLOAD_SLOT_TYPES.visaGrant,
    label: 'Visa Grant Notice',
    name: '',
    required: false,
    allowPreview: false,
  },
]

export const internationalStudentUploadSlots: UploadSlotDefinition[] = [
  {
    type: UPLOAD_SLOT_TYPES.internationalCoe,
    label: 'Confirmation of Enrolment (CoE)',
    name: 'COE',
  },
  {
    type: UPLOAD_SLOT_TYPES.enrollmentLetter,
    label: 'Enrolment Letter',
    name: 'Enrolment Letter',
  },
]

export const companyUploadSlots: UploadSlotDefinition[] = [
  {type: UPLOAD_SLOT_TYPES.letterOfAuthority, label: 'Letter Of Authority'},
]

export const requiredUploadSlotTypes: UploadSlotType[] = [
  UPLOAD_SLOT_TYPES.identityFront,
  UPLOAD_SLOT_TYPES.identityBack,
  UPLOAD_SLOT_TYPES.incomeDoc1,
  UPLOAD_SLOT_TYPES.incomeDoc2,
]
